import { render, staticRenderFns } from "./PredictionPage.vue?vue&type=template&id=33c9d429&"
import script from "./PredictionPage.vue?vue&type=script&lang=js&"
export * from "./PredictionPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports